import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/layout/index.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login.vue')
  },
  {
    path: '/',
    component: Layout,
    redirect: '/dashboard',
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('@/views/dashboard.vue'),
        meta: { title: '数据概览' }
      },
      {
        path: 'users',
        name: 'Users',
        component: () => import('@/views/users/index.vue'),
        meta: { title: '用户管理' }
      },
      {
        path: 'friends',
        name: 'Friends',
        component: () => import('@/views/friends/index.vue'),
        meta: { title: '亲友管理' }
      },
      {
        path: 'books',
        name: 'Books',
        component: () => import('@/views/books/index.vue'),
        meta: { title: '账本管理' }
      },
      {
        path: 'gifts',
        name: 'Gifts',
        component: () => import('@/views/gifts/index.vue'),
        meta: { title: '人情往来管理' }
      },
      {
        path: 'logs',
        name: 'Logs',
        component: () => import('@/views/logs/index.vue'),
        meta: { title: '日志管理' }
      },
      {
        path: 'event-types',
        name: 'EventTypes',
        component: () => import('@/views/eventTypes/index.vue'),
        meta: { title: '事件类型管理' }
      },
      {
        path: 'login-locations',
        name: 'LoginLocations',
        component: () => import('@/views/loginLocations/index.vue'),
        meta: { title: '登录位置管理' }
      },
      {
        path: 'membership-plans',
        name: 'MembershipPlans',
        component: () => import('@/views/membership/plans.vue'),
        meta: { title: '会员套餐管理' }
      },
      
      {
        path: 'membership-orders',
        name: 'MembershipOrders',
        component: () => import('@/views/membership/orders.vue'),
        meta: { title: '订单管理' }
      },
      {
        path: 'feedbacks',
        name: 'Feedbacks',
        component: () => import('@/views/feedbacks/index.vue'),
        meta: { title: '意见反馈管理' }
      },
      {
        path: 'user-behavior',
        name: 'UserBehavior',
        component: () => import('@/views/userBehavior/index.vue'),
        meta: { title: '用户行为监控' }
      },
      {
        path: 'messages',
        name: 'Messages',
        component: () => import('@/views/messages/index.vue'),
        meta: { title: '站内信管理' }
      },
      {
        path: 'materials',
        name: 'Materials',
        component: () => import('@/views/materials/index.vue'),
        meta: { title: '素材中心' }
      },
      {
        path: 'tongji',
        name: 'Tongji',
        component: () => import('@/views/apiStatistics/index.vue'),
        meta: { title: '统计管理' }
      },
      {
        path: 'daily-text',
        name: 'DailyText',
        component: () => import('@/views/dailyText/index.vue'),
        meta: { title: '每日文案管理' }
      },
      {
        path: 'changelog',
        name: 'Changelog',
        component: () => import('@/views/changelog/index.vue'),
        meta: { title: '更新日志管理' }
      },
      {
        path: 'tarot',
        name: 'Tarot',
        component: () => import('@/views/tarot/index.vue'),
        meta: { title: '塔罗牌管理' }
      },
      {
        path: 'customs',
        name: 'Customs',
        component: () => import('@/views/customs/index.vue'),
        meta: { title: '地域礼俗管理' }
      },
      {
        path: 'almanac',
        name: 'Almanac',
        component: () => import('@/views/almanac/index.vue'),
        meta: { title: '老黄历管理' }
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// 导航状态跟踪
let isNavigating = false
let pendingNavigation = null

// 路由守卫
router.beforeEach((to, from, next) => {
  // 如果目标路径与当前路径相同，直接返回（避免重复导航）
  if (to.path === from.path) {
    next(false)
    return
  }

  // 如果正在导航到相同路径，取消当前导航
  if (isNavigating && pendingNavigation && pendingNavigation.path === to.path) {
    next(false)
    return
  }

  // 设置导航状态
  isNavigating = true
  pendingNavigation = to

  const token = localStorage.getItem('admin_token')
  if (to.path === '/login') {
    next()
  } else if (!token) {
    next('/login')
  } else {
    next()
  }
})

// 导航完成后重置状态
router.afterEach(() => {
  isNavigating = false
  pendingNavigation = null
})

// 捕获导航错误
router.onError((error) => {
  // 如果是导航取消错误，静默处理（不显示错误）
  if (error.message && (
    error.message.includes('Navigation cancelled') ||
    error.message.includes('NavigationDuplicated')
  )) {
    // 静默处理导航取消错误
    return
  }
  // 其他错误才输出到控制台
  console.error('路由错误:', error)
})

export default router

